<template>
  <StepMenuLayout
    :hiddenTitle="hiddenTitle"
    class="step-form-layout"
    :activeMenuIndex="activeMenuIndex"
    :activeStandaloneMenuIndex="activeStandaloneMenuIndex"
    :stepMenuList="stepMenuList"
    :standaloneStepMenuList="standaloneStepMenuList"
    :loading="loading"
    @step-change="handleActiveMenuChange"
    @standalone-step-change="handleActiveStandaloneMenuChange"
    @shrink-change="handelShrinkChange"
  >
    <div class="form-container">
      <slot name="resume-view">
      </slot>
      <slot>
        <router-view></router-view>
      </slot>
    </div>
    <div v-if="showAgencyPolicy && isActiveLastStep" class="agency-policy">
      <span class="tips">{{ $t('personal.resume.tips.agencySubmitPolicy') }}</span>
    </div>
    <div v-if="!hiddenStepBtn" class="form-action-btn-group adapt-wrapper">
      <slot name="form-footer">
        <el-button
          v-if="!isActiveFirstStep"
          class="action-btn prev-btn grey-btn"
          @click="handlePrevBtnClick"
        >{{ $t(`common.btn.prev`) }}</el-button>
        <el-button
          class="action-btn cancel-btn grey-btn"
          @click="handleCancelBtnClick"
        >{{ $t(cancelBtnTextI18nKey) }}</el-button>
        <el-button
          v-if="isPreview"
          class="action-btn preview-btn blue-btn"
          @click="handleShowPreview"
        >{{ $t(`common.btn.preview`) }}</el-button>
        <el-button
          v-if="!hiddenSaveBtn && (!saveInLastStep || isActiveLastStep)"
          class="action-btn save-btn blue-btn"
          @click="handleSaveBtnClick(SAVE_BTN_TYPE.STEP_PROCESS)"
        >{{ $t(saveBtnTextKey || 'common.btn.save') }}</el-button>
        <el-button
          v-if="!isActiveLastStep"
          class="action-btn next-btn blue-btn"
          @click="handleNextBtnClick"
        >{{ $t(`common.btn.next`) }}</el-button>
        <el-button
          v-if="showRightBtn"
          class="action-btn blue-btn"
          @click="handleRightBtnClick"
        >{{ $t(rightBtnTextI18nKey) }}</el-button>
      </slot>
    </div>
    <div v-if="hiddenStepBtn" class="form-action-btn-group adapt-wrapper">
      <slot name="form-footer">
        <el-button
          class="action-btn cancel-btn grey-btn"
          @click="handleCancelBtnClick"
        >{{ $t(`common.btn.cancel`) }}</el-button>
        <el-button
          v-if="!isJobFitStepBtn"
          class="action-btn save-btn blue-btn"
          @click="handleSaveBtnClick(SAVE_BTN_TYPE.COMPARISON)"
        >{{ $t( saveBtnTextKey || 'common.btn.save') }}</el-button>
<!--
        先隐藏
        <el-button
          v-if="isJobFitStepBtn"
          class="action-btn test-candidate-btn blue-btn"
          @click="handleAiMatchTestCandidate"
        >{{ $t('admin.job.editor.btn.testCandidate') }}</el-button>
-->
        <el-button
          v-if="isJobFitStepBtn"
          class="action-btn reset-btn grey-btn"
          @click="handleResetGeneration"
        >
          {{ $t('admin.application.applicantList.btn.talentRecommendation.reset') }}
        </el-button>
        <el-button
          v-if="isJobFitStepBtn"
          class="action-btn save-btn blue-btn"
          @click="handleSaveBtnClick(SAVE_BTN_TYPE.JOB_FIT)"
        >{{ $t( saveBtnTextKey || 'common.btn.save') }}</el-button>
      </slot>
    </div>
  </StepMenuLayout>
</template>

<script>
import StepMenuLayout from './menuLayout.vue'

const SAVE_BTN_TYPE = {
  STEP_PROCESS: 'stepProcess',
  COMPARISON: 'comparison',
  JOB_FIT: 'job_fit'
}

export default {
  components: {
    StepMenuLayout
  },
  props: {
    activeMenuIndex: {
      type: Number,
      required: true
    },
    stepMenuList: {
      type: Array,
      required: true
    },
    activeStandaloneMenuIndex: {
      type: Number,
      required: false
    },
    standaloneStepMenuList: {
      type: Array,
      required: false
    },
    isJobFitStepBtn: {
      type: Boolean,
      required: false
    },
    hiddenTitle: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    saveInLastStep: {
      type: Boolean,
      default: false
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    saveBtnTextKey: {
      type: String,
      default: ''
    },
    hasResumeView: {
      type: Boolean,
      default: false
    },
    hiddenStepBtn: {
      type: Boolean,
      default: false
    },
    hiddenSaveBtn: {
      type: Boolean,
      default: false
    },
    showAgencyPolicy: {
      type: Boolean,
      default: false
    },
    cancelBtnTextI18nKey: {
      type: String,
      default: 'common.btn.cancel'
    },
    showRightBtn: {
      type: Boolean,
      default: false
    },
    rightBtnTextI18nKey: {
      type: String
    }
  },
  data () {
    return {
      SAVE_BTN_TYPE
    }
  },
  computed: {
    isActiveFirstStep () {
      if (this.activeMenuIndex !== 0) {
        return false
      }
      const firstStep = this.stepMenuList[0]
      return firstStep?.stepType === this.stepMenuList[this.activeMenuIndex].stepType
    },
    isActiveLastStep () {
      if (this.activeMenuIndex === undefined || this.activeMenuIndex === null) {
        return false
      }
      const lastStep = this.stepMenuList[this.stepMenuList.length - 1]
      return lastStep?.stepType === this.stepMenuList[this.activeMenuIndex].stepType
    }
  },
  created () {

  },
  methods: {
    handleActiveMenuChange (activeMenuIndex) {
      this.$emit('step-change', activeMenuIndex)
    },
    handleActiveStandaloneMenuChange (activeMenuIndex) {
      this.$emit('standalone-step-change', activeMenuIndex)
    },
    handelShrinkChange () {
      this.$emit('shrink-change')
    },
    handlePrevBtnClick () {
      this.$emit('prev')
    },
    handleCancelBtnClick () {
      this.$emit('cancel')
    },
    handleShowPreview () {
      this.$emit('preview')
    },
    handleAiMatchTestCandidate () {
      this.$eventBus.$emit('testJobFitCondition')
    },
    handleResetGeneration () {
      this.$eventBus.$emit('resetGeneration')
    },
    handleSaveBtnClick (type) {
      if (type === SAVE_BTN_TYPE.STEP_PROCESS) {
        this.$emit('save')
      } else if (type === SAVE_BTN_TYPE.COMPARISON) {
        this.$emit('ai-comparison-save')
      } else if (type === SAVE_BTN_TYPE.JOB_FIT) {
        this.$emit('job-fit-save')
      }
    },
    handleNextBtnClick () {
      this.$emit('next')
    },
    handleRightBtnClick () {
      this.$emit('rightBtnClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.step-form-layout {
  ::v-deep {
    .layout-content {
      display: flex;
      flex-direction: column;
    }
  }

  .form-container {
    flex: 1;
    margin: 25px 50px 50px;
    display: flex;
    align-items: flex-start;

    ::v-deep {
      > * {
        &:last-child {
          min-height: 60vh;
        }

        flex: 1;
        width: 50%;
      }
    }
  }

  .form-action-btn-group {
    display: flex;
    justify-content: space-between;

    .action-btn {
      padding: 5px 25px;
      line-height: normal;

      &.cancel-btn {
        margin-right: auto;
      }
    }
  }

  .agency-policy {
    text-align: right;
    margin-bottom: 10px;
    margin-left: auto;
    max-width: 700px;

    .tips {
      display: inline-block;
      text-align: left;
      line-height: 18px;
    }
  }
}
</style>
